import { DEFAULT_LAUNCH_LOCATION } from "@/lib/location/defaults";

export const LOCATION_SUGGESTION_LIMIT = 5;
export const LOCATION_SUGGESTION_MIN_QUERY_LENGTH = 2;

const finiteCoordinate = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export function getLocationSuggestionProximity(location) {
  const lat = finiteCoordinate(location?.lat);
  const lng = finiteCoordinate(location?.lng);
  if (lat !== null && lng !== null) {
    return { lat, lng };
  }
  return {
    lat: DEFAULT_LAUNCH_LOCATION.lat,
    lng: DEFAULT_LAUNCH_LOCATION.lng,
  };
}

export function buildLocationSuggestionPath(query, location, { debug = false } = {}) {
  const proximity = getLocationSuggestionProximity(location);
  const params = new URLSearchParams({
    q: String(query || "").trim(),
    lat: String(proximity.lat),
    lng: String(proximity.lng),
  });
  if (debug) params.set("debug", "1");
  return `/api/location-suggest?${params.toString()}`;
}
